import { useRef, useState, useEffect } from 'react';

const useDropdownFilterButton = ({ openedProp, onClick, onOpenedChange }) => {
    const dropdownRef = useRef();
    const [opened, setOpened] = useState(openedProp);

    const handleClick = () => {
        setOpened((opened) => !opened);
        onClick();
    };

    useEffect(() => {
        if (openedProp !== undefined) {
            setOpened(openedProp);
        }
    }, [openedProp]);

    useEffect(() => {
        onOpenedChange(opened);
    }, [opened, onOpenedChange]);

    useEffect(() => {
        const listener = (e) => {
            const dropdown = dropdownRef.current;
            const shouldClose = !e.composedPath().includes(dropdown);
            if (shouldClose) {
                setOpened(false);
            }
        };
        if (opened) {
            window.addEventListener('click', listener);
        } else {
            window.removeEventListener('click', listener);
        }
        return () => {
            window.removeEventListener('click', listener);
        };
    }, [opened]);

    return {
        opened,
        handleClick,
        dropdownRef,
    };
};

export default useDropdownFilterButton;
